// estimation.helper.ts
import { ApiToolsService } from "../services/api-tools.service";
import { RENOVATION_MAP, RenovationKey } from "../const/renovation-type";
import { cloneDeep } from "lodash";
import { Observable, of, throwError } from "rxjs";
import { switchMap, tap, map, catchError } from "rxjs/operators";

/**
 * Récupère le batiment puis le type de rénovation et finalement les pièces associées et les stocke en localStorage.
 * Retourne un Observable<void> pour que le composant appelant puisse chaîner (navigation, modals, etc).
 */
export function getEstimationFromId(SimId: number, apiToolsService: ApiToolsService): Observable<void> {
	// cast explicite pour éviter l'inférence trop générique
	return (apiToolsService.getBatimentSimulation(SimId) as Observable<any>).pipe(
		switchMap((data: any): Observable<void> => {
			if (!data) {
				return throwError(new Error("No batiment data"));
			}

			// Sauvegarde batiment + renovation
			localStorage.setItem("BATIMENT", JSON.stringify(data));
			getRenovationFromSimulation(data.renovation);

			// Ensuite récupère et stocke les pièces (retourne Observable<void>)
			const simuId = data.simulationId ?? SimId;
			return getPiecesFromSimulation(simuId, apiToolsService);
		}),
		catchError(err => {
			console.error("getEstimationFromId error", err);
			return throwError(err);
		})
	);
}

/**
 * Récupère les pièces et les stocke en localStorage.
 * Ne renvoie pas le tableau : on renvoie un Observable<void> pour indiquer la fin de l'opération.
 */
export function getPiecesFromSimulation(SimId: number, apiToolsService: ApiToolsService): Observable<void> {
	const id = parseInt(SimId.toString());
	return (apiToolsService.getSinistreByID(id, true) as Observable<any>).pipe(
		// map la réponse en tableau mais on convertit ensuite en void
		map((res: any): any[] => cloneDeep(res || [])),
		tap((arrPieces: any[]) => {
			// stocke même si vide
			localStorage.setItem("arrPieces", JSON.stringify(arrPieces));
		}),
		// convertit en Observable<void> (on renvoie undefined comme valeur)
		map(() => void 0),
		catchError(err => {
			console.error("getPiecesFromSimulation error", err);
			// fallback : on stocke un tableau vide et on renvoie void pour que le caller puisse continuer
			localStorage.setItem("arrPieces", JSON.stringify([]));
			return of(void 0);
		})
	);
}

export function getRenovationFromSimulation(dataRenovation: RenovationKey) {
	const renovationKey: RenovationKey = dataRenovation as RenovationKey;
	let renovation: string = RENOVATION_MAP[renovationKey] ?? "";
	console.log("renovation → ", renovation);

	if (renovation == "") {
		console.warn("renovation:", renovation);
		return;
	}
	localStorage.setItem("RENOVATION", renovation);
}
